module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "data-pdf-bookmark": "Title Page",
      "data-titlepage": "yes",
      "data-type": "titlepage",
      "epub:type": "titlepage"
    }
  }, [_c('div', {
    staticClass: "preface",
    attrs: {
      "id": "d1e222"
    }
  }, [_c('h1', {
    staticClass: "ChapTitleNonprintingctnp"
  }, [_vm._v("Title Page")]), _c('img', {
    staticClass: "titlepage",
    attrs: {
      "src": "epubtitlepage.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d14f83a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/titlepage01.vue
// module id = 57
// module chunks = 0